var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('block-alert'),_c('block-photo'),_c('block-twitter',{staticClass:"mt-10"}),_c('block-youtube'),_c('block-info'),_c('block-parallax',{staticClass:"mt-10"}),_c('block-gif',{staticClass:"mt-10"}),_c('block-test')],1)}
var staticRenderFns = []

export { render, staticRenderFns }